import * as React from 'react';
import { OpenVillageBanner } from '../../components/OpenVillageBanner';
import { useBannerConfig } from './hooks/useBannerConfig';

export const OpenVillageBannerContainer = () => {
  const bannerConfig = useBannerConfig();

  if (!bannerConfig) {
    return null;
  }

  return <OpenVillageBanner {...bannerConfig} />;
};
